import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserAccountsEffects } from './effects/user-accounts.effects';
import { reducers } from './reducers';

@NgModule({
  imports: [
    StoreModule.forFeature('userAccountsState', reducers),
    EffectsModule.forFeature([
      UserAccountsEffects
    ])
  ]
})
export class UserAccountsStoreModule {
}
